import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

import amagicalCrudInit from "amagical-crud"

const application = Application.start()
const controllers = import.meta.glob('~/**/*_controller.js', { eager: true })
registerControllers(application, controllers)

amagicalCrudInit(application)

import '~/javascript/fonts'
import '~/stylesheets/application.css'
